module.exports = __webpack_public_path__ + "img/text_howto.f22f368c.png";